var render = function render(){
  var _vm$getSelectedNode, _vm$getSelectedNode$n, _vm$getSelectedNode2, _vm$getSelectedNode2$;

  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.visible,
      expression: "visible"
    }]
  }, [_c('div', {
    staticClass: "popup_wrap editAttribute"
  }, [_c('div', {
    staticClass: "popup_title",
    style: _vm.setBackgroundColor((_vm$getSelectedNode = _vm.getSelectedNode) === null || _vm$getSelectedNode === void 0 ? void 0 : (_vm$getSelectedNode$n = _vm$getSelectedNode.node) === null || _vm$getSelectedNode$n === void 0 ? void 0 : _vm$getSelectedNode$n.category)
  }, [_c('p', [_c('span', {
    attrs: {
      "id": "node_title"
    }
  }, [_vm._v(_vm._s((_vm$getSelectedNode2 = _vm.getSelectedNode) === null || _vm$getSelectedNode2 === void 0 ? void 0 : (_vm$getSelectedNode2$ = _vm$getSelectedNode2.node) === null || _vm$getSelectedNode2$ === void 0 ? void 0 : _vm$getSelectedNode2$.text))])]), _c('a', [_c('div', {
    staticClass: "btn_close",
    attrs: {
      "id": "popup_close",
      "title": "Close"
    },
    on: {
      "click": _vm.close
    }
  }, [_vm._m(0)])])]), _c('div', {
    staticClass: "popup_content1"
  }, [_c('div', {
    staticClass: "node_order_wrap"
  }, [_c('div', {
    staticClass: "node_order_box_left"
  }, [_c('h4', {
    staticClass: "node_order_tit"
  }, [_vm._v("강제순서")]), _c('p', {
    staticStyle: {
      "color": "red",
      "font-size": "12px"
    }
  }, [_vm._v(" ※사용자가 노드의 순서를 강제로 지정할 수 있습니다. 사용 설정 시 나머지 노드는 사용자가 강제로 순서를 지정한 노드의 순서를 제외하고 자동으로 배정됩니다. ")]), _c('div', {
    staticClass: "node_name_box"
  }, [_c('div', {
    staticClass: "box_stitle2 node_title W100"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.input.nodeForceOrder,
      expression: "input.nodeForceOrder"
    }],
    staticClass: "W100 validate[required]",
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "type": "text",
      "data-key": "input",
      "readonly": !_vm.input.forceOrderUseYn
    },
    domProps: {
      "value": _vm.input.nodeForceOrder
    },
    on: {
      "input": [function ($event) {
        if ($event.target.composing) return;

        _vm.$set(_vm.input, "nodeForceOrder", $event.target.value);
      }, function ($event) {
        return _vm.inputListener($event, 'nodeForceOrder');
      }],
      "keydown": function ($event) {
        return _vm.keydownListener($event, 'nodeForceOrder');
      }
    }
  }), _c('label', {
    attrs: {
      "for": "use"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.input.forceOrderUseYn,
      expression: "input.forceOrderUseYn"
    }],
    attrs: {
      "type": "radio",
      "name": "forceOrderUseYn",
      "id": "use"
    },
    domProps: {
      "value": true,
      "checked": _vm._q(_vm.input.forceOrderUseYn, true)
    },
    on: {
      "change": function ($event) {
        return _vm.$set(_vm.input, "forceOrderUseYn", true);
      }
    }
  }), _c('span', [_vm._v("사용")])]), _c('label', {
    attrs: {
      "for": "notuse"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.input.forceOrderUseYn,
      expression: "input.forceOrderUseYn"
    }],
    attrs: {
      "type": "radio",
      "name": "forceOrderUseYn",
      "id": "notuse"
    },
    domProps: {
      "value": false,
      "checked": _vm._q(_vm.input.forceOrderUseYn, false)
    },
    on: {
      "change": function ($event) {
        return _vm.$set(_vm.input, "forceOrderUseYn", false);
      }
    }
  }), _c('span', [_vm._v("미사용")])]), _c('br')])]), _c('h4', {
    staticClass: "node_order_tit"
  }, [_vm._v(" 속성 ")]), _c('table', {
    staticClass: "board_node",
    attrs: {
      "width": "100%",
      "border": "0",
      "cellspacing": "0",
      "cellpadding": "0"
    }
  }, [_vm._m(1), _c('tbody', [_c('tr', [_c('th', [_vm._v(" 속성명 ")]), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.input.propertyName,
      expression: "input.propertyName"
    }],
    attrs: {
      "type": "text",
      "data-key": "input"
    },
    domProps: {
      "value": _vm.input.propertyName
    },
    on: {
      "input": [function ($event) {
        if ($event.target.composing) return;

        _vm.$set(_vm.input, "propertyName", $event.target.value);
      }, function ($event) {
        return _vm.inputListener($event, 'propertyName');
      }],
      "keydown": function ($event) {
        return _vm.keydownListener($event, 'propertyName');
      }
    }
  })])]), _c('tr', [_c('th', {
    staticStyle: {
      "vertical-align": "middle"
    }
  }, [_vm._v("속성타입")]), _c('td', _vm._l(Object.values(_vm.PROPERTY_TYPE), function (type, index) {
    return _c('label', {
      key: index,
      attrs: {
        "for": index
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: _vm.input.propertyType,
        expression: "input.propertyType"
      }],
      attrs: {
        "type": "radio",
        "name": "propertyType",
        "id": index
      },
      domProps: {
        "value": type.value,
        "checked": _vm._q(_vm.input.propertyType, type.value)
      },
      on: {
        "change": function ($event) {
          return _vm.$set(_vm.input, "propertyType", type.value);
        }
      }
    }), _c('span', [_vm._v(_vm._s(type.label))])]);
  }), 0)]), _c('tr', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.isDistrictValid.includes(_vm.input.propertyType),
      expression: "!isDistrictValid.includes(input.propertyType)"
    }]
  }, [_c('th', [_vm._v("속성단위")]), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.input.propertyUnit,
      expression: "input.propertyUnit"
    }],
    attrs: {
      "type": "text",
      "data-key": "input"
    },
    domProps: {
      "value": _vm.input.propertyUnit
    },
    on: {
      "input": [function ($event) {
        if ($event.target.composing) return;

        _vm.$set(_vm.input, "propertyUnit", $event.target.value);
      }, function ($event) {
        return _vm.inputListener($event, 'propertyUnit');
      }],
      "keydown": function ($event) {
        return _vm.keydownListener($event, 'propertyUnit');
      }
    }
  })])]), _c('tr', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.isDistrictValid.includes(_vm.input.propertyType),
      expression: "!isDistrictValid.includes(input.propertyType)"
    }]
  }, [_c('th', [_vm._v("속성기본값")]), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.input.propertyValue,
      expression: "input.propertyValue"
    }],
    attrs: {
      "type": "text",
      "data-key": "input"
    },
    domProps: {
      "value": _vm.input.propertyValue
    },
    on: {
      "input": [function ($event) {
        if ($event.target.composing) return;

        _vm.$set(_vm.input, "propertyValue", $event.target.value);
      }, function ($event) {
        return _vm.inputListener($event, 'propertyValue');
      }],
      "keydown": function ($event) {
        return _vm.keydownListener($event, 'propertyValue');
      }
    }
  })])]), _c('tr', [_c('th', {
    staticStyle: {
      "vertical-align": "middle"
    }
  }, [_vm._v("어휘번호")]), _c('td', [_c('VocabularyAutocomplete', {
    ref: "vocabularyAutocomplete",
    attrs: {
      "selectedVocabularyId": _vm.input.propertyVocabularyId
    },
    on: {
      "select": _vm.handleVocabularySelect
    }
  })], 1)]), _c('tr', [_c('th', {
    staticStyle: {
      "vertical-align": "middle"
    }
  }, [_vm._v("class")]), _c('td', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.input.propertyClassId,
      expression: "input.propertyClassId"
    }],
    attrs: {
      "data-key": "input"
    },
    on: {
      "change": [function ($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });

        _vm.$set(_vm.input, "propertyClassId", $event.target.multiple ? $$selectedVal : $$selectedVal[0]);
      }, function ($event) {
        return _vm.inputListener($event, 'propertyClassId');
      }]
    }
  }, _vm._l(_vm.getPropertyClassList, function (propertyClass, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": propertyClass === null || propertyClass === void 0 ? void 0 : propertyClass.id
      }
    }, [_vm._v(_vm._s(propertyClass === null || propertyClass === void 0 ? void 0 : propertyClass.name))]);
  }), 0)])]), _c('tr', [_c('th', {
    staticStyle: {
      "vertical-align": "middle"
    }
  }, [_vm._v("속성설명")]), _c('td', [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.input.propertyDefine,
      expression: "input.propertyDefine"
    }],
    staticStyle: {
      "resize": "none"
    },
    attrs: {
      "type": "text",
      "data-key": "input",
      "rows": "8"
    },
    domProps: {
      "value": _vm.input.propertyDefine
    },
    on: {
      "input": [function ($event) {
        if ($event.target.composing) return;

        _vm.$set(_vm.input, "propertyDefine", $event.target.value);
      }, function ($event) {
        return _vm.inputListener($event, 'propertyDefine');
      }],
      "keydown": function ($event) {
        return _vm.keydownListener($event, 'propertyDefine');
      }
    }
  })])])])]), _c('div', {
    staticClass: "text_right mt10"
  }, [_c('a', {
    staticClass: "btn_add",
    on: {
      "click": _vm.addDictionaryProperty
    }
  }, [_vm._v("속성추가")])])]), _c('div', {
    staticClass: "node_order_box_right"
  }, [_c('h4', {
    staticClass: "node_order_tit"
  }, [_vm._v("공정도적용속성")]), _vm._l(_vm.sortedProcessAttributes.filter(function (item) {
    return item.active;
  }), function (prop, index) {
    var _Object$values$find, _prop$propertyVocabul, _prop$propertyClass, _prop$propertyClass2;

    return _c('div', {
      key: prop.uuid,
      staticClass: "node_result_box",
      attrs: {
        "draggable": true
      },
      on: {
        "dragstart": function ($event) {
          return _vm.attrDragStart($event, index);
        },
        "dragover": function ($event) {
          $event.preventDefault();
        },
        "drop": function ($event) {
          return _vm.attrDragDrop($event, index);
        }
      }
    }, [_c('h4', {
      staticClass: "site_detail_tit"
    }, [_vm._v(" " + _vm._s(prop.propertyName) + " "), prop.propertyDefine != null && prop.propertyDefine != '' ? _c('div', {
      directives: [{
        name: "b-toggle",
        rawName: "v-b-toggle",
        value: `edit-attr-process-collapse-${index}`,
        expression: "`edit-attr-process-collapse-${index}`"
      }],
      staticClass: "tooltip_box",
      attrs: {
        "title": "속성설명을 보려면 클릭해주세요."
      }
    }, [_c('span', {
      staticClass: "tooltip_ico"
    })]) : _vm._e(), _c('div', {
      staticClass: "node_result_box_btn"
    }, [_c('a', {
      staticClass: "btn_node_delete",
      on: {
        "click": function ($event) {
          return _vm.deleteAttribute('processAttribute', prop.uuid);
        }
      }
    }, [_vm._v(" ")]), _c('a', {
      staticClass: "btn_node_change"
    }, [_vm._v(" ")])])]), _c('div', {
      staticClass: "site_detail_con"
    }, [_c('h4', {
      staticClass: "site_detail_con"
    }, [_vm._v("단위 : " + _vm._s(prop.propertyUnit != null && prop.propertyUnit != "" ? prop.propertyUnit : "없음") + " | 타입 : " + _vm._s(prop.propertyType != null ? (_Object$values$find = Object.values(_vm.PROPERTY_TYPE).find(function (item) {
      return item.value == prop.propertyType;
    })) === null || _Object$values$find === void 0 ? void 0 : _Object$values$find.label : "-") + " ")]), !_vm.strIsNull((_prop$propertyVocabul = prop.propertyVocabulary) === null || _prop$propertyVocabul === void 0 ? void 0 : _prop$propertyVocabul.code) ? _c('h4', [_vm._v(" 어휘번호 : " + _vm._s(_vm.createViewVocabularyString(prop.propertyVocabulary)) + " ")]) : _vm._e(), !_vm.strIsNull((_prop$propertyClass = prop.propertyClass) === null || _prop$propertyClass === void 0 ? void 0 : _prop$propertyClass.name) ? _c('h4', [_vm._v("class : " + _vm._s((_prop$propertyClass2 = prop.propertyClass) === null || _prop$propertyClass2 === void 0 ? void 0 : _prop$propertyClass2.name) + " ")]) : _vm._e(), !_vm.isDistrictValid.includes(prop.propertyType) ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: prop.propertyValue,
        expression: "prop.propertyValue"
      }],
      staticClass: "W100",
      staticStyle: {
        "margin-top": "5px"
      },
      attrs: {
        "type": "text",
        "data-key": "processAttribute",
        "data-attributeId": prop.uuid
      },
      domProps: {
        "value": prop.propertyValue
      },
      on: {
        "input": [function ($event) {
          if ($event.target.composing) return;

          _vm.$set(prop, "propertyValue", $event.target.value);
        }, function ($event) {
          return _vm.inputListener($event, prop.uuid);
        }],
        "keydown": function ($event) {
          return _vm.keydownListener($event, prop.uuid);
        }
      }
    }) : _vm._e()]), prop.propertyDefine != null && prop.propertyDefine != '' ? _c('div', [_c('b-collapse', {
      staticClass: "mt-2",
      staticStyle: {
        "cursor": "default"
      },
      attrs: {
        "id": `edit-attr-process-collapse-${index}`
      }
    }, [_c('b-card', {
      on: {
        "click": function ($event) {
          $event.stopPropagation();
        }
      }
    }, [_c('p', {
      staticStyle: {
        "white-space": "pre-line",
        "text-align": "left",
        "font-size": "13px",
        "font-weight": "bold"
      }
    }, [_vm._v(_vm._s(prop.propertyDefine))])])], 1)], 1) : _vm._e()]);
  }), _vm.sortedProcessAttributes.filter(function (item) {
    return item.active;
  }).length == 0 ? _c('div', [_vm._m(2)]) : _vm._e()], 2), _c('div', {
    staticClass: "node_order_box_middle"
  }, [_c('h4', {
    staticClass: "node_order_tit"
  }, [_vm._v("속성POOL")]), _c('div', {
    staticClass: "search_form_wrap"
  }, [_c('ul', {
    staticClass: "search_form_list"
  }, [_c('li', {
    staticStyle: {
      "width": "87.5%"
    }
  }, [_c('div', {
    staticClass: "inpt_sch"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.searchQuery,
      expression: "searchQuery"
    }],
    staticClass: "form_control",
    staticStyle: {
      "background-color": "white"
    },
    attrs: {
      "type": "text",
      "data-key": "searchQuery",
      "placeholder": "속성명 검색을 할수있어요."
    },
    domProps: {
      "value": _vm.searchQuery
    },
    on: {
      "input": [function ($event) {
        if ($event.target.composing) return;
        _vm.searchQuery = $event.target.value;
      }, function ($event) {
        return _vm.inputListener($event, 'searchQuery');
      }],
      "keydown": function ($event) {
        return _vm.keydownListener($event, 'searchQuery');
      }
    }
  }), _c('button', {
    attrs: {
      "type": "button"
    }
  })])]), _c('li', {
    staticStyle: {
      "width": "12.5%"
    }
  }, [_c('div', {
    staticClass: "inpt_sch"
  }, [_c('button', {
    staticClass: "eraser",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function ($event) {
        _vm.searchQuery = null;
      }
    }
  })])])])]), _c('p', {
    staticStyle: {
      "font-size": "14px",
      "text-align": "right"
    }
  }, [_vm._v(" 검색조건 결과 : " + _vm._s(_vm.dictionaryAttribute.filter(function (item) {
    return item.searchFlag && item.active;
  }).length) + "개 / 총 : " + _vm._s(_vm.dictionaryAttribute.filter(function (item) {
    return item.active;
  }).length) + "개 ")]), _vm._l(_vm.dictionaryAttribute.filter(function (item) {
    return item.active && item.searchFlag;
  }), function (prop, index) {
    var _Object$values$find2, _prop$propertyVocabul2, _prop$propertyClass3, _prop$propertyClass4;

    return _c('div', {
      key: prop.uuid,
      staticClass: "node_result_box",
      style: _vm.setExistColor(prop)
    }, [_c('h4', {
      staticClass: "site_detail_tit"
    }, [_vm._v(" " + _vm._s(prop.propertyName) + " "), _c('a', {
      staticClass: "btn_node_edit",
      attrs: {
        "title": "수정"
      },
      on: {
        "click": function ($event) {
          return _vm.callEditAttributePollPop(prop);
        }
      }
    }), _c('div', {
      staticClass: "node_result_box_btn"
    }, [_c('a', {
      staticClass: "btn_node_delete",
      attrs: {
        "title": "삭제"
      },
      on: {
        "click": function ($event) {
          return _vm.deleteAttribute('dictionaryAttribute', prop.uuid);
        }
      }
    }, [_vm._v(" ")]), _c('a', {
      staticClass: "btn_node_plus",
      attrs: {
        "title": "공정도적용속성으로 추가"
      },
      on: {
        "click": function ($event) {
          return _vm.addProcessAttribute(prop.dictionaryPropertyId, prop.uuid);
        }
      }
    })])]), _c('div', {
      staticClass: "site_detail_con"
    }, [_c('h4', {
      staticClass: "site_detail_con"
    }, [_vm._v("단위 : " + _vm._s(prop.propertyUnit != null && prop.propertyUnit != "" ? prop.propertyUnit : "없음") + " | 타입 : " + _vm._s(prop.propertyType != null ? (_Object$values$find2 = Object.values(_vm.PROPERTY_TYPE).find(function (item) {
      return item.value == prop.propertyType;
    })) === null || _Object$values$find2 === void 0 ? void 0 : _Object$values$find2.label : "-") + " ")]), !_vm.isDistrictValid.includes(prop.propertyType) ? _c('h4', [_vm._v("속성기본값 : " + _vm._s(prop.propertyValue != null && prop.propertyValue != "" ? prop.propertyValue : "") + " ")]) : _vm._e(), !_vm.strIsNull((_prop$propertyVocabul2 = prop.propertyVocabulary) === null || _prop$propertyVocabul2 === void 0 ? void 0 : _prop$propertyVocabul2.code) ? _c('h4', [_vm._v("어휘번호 : " + _vm._s(_vm.createViewVocabularyString(prop.propertyVocabulary)) + " ")]) : _vm._e(), !_vm.strIsNull((_prop$propertyClass3 = prop.propertyClass) === null || _prop$propertyClass3 === void 0 ? void 0 : _prop$propertyClass3.name) ? _c('h4', [_vm._v("class : " + _vm._s((_prop$propertyClass4 = prop.propertyClass) === null || _prop$propertyClass4 === void 0 ? void 0 : _prop$propertyClass4.name) + " ")]) : _vm._e(), prop.propertyDefine != null && prop.propertyDefine != '' ? _c('h4', {
      staticStyle: {
        "margin-top": "5px"
      }
    }, [_vm._v(" 속성설명 : "), _c('div', {
      directives: [{
        name: "b-toggle",
        rawName: "v-b-toggle",
        value: `edit-dictionary-attr-collapse-${index}`,
        expression: "`edit-dictionary-attr-collapse-${index}`"
      }],
      staticClass: "tooltip_box",
      attrs: {
        "title": "속성설명을 보려면 클릭해주세요."
      }
    }, [_c('span', {
      staticClass: "tooltip_ico"
    })])]) : _vm._e()]), prop.propertyDefine != null && prop.propertyDefine != '' ? _c('div', [_c('b-collapse', {
      staticClass: "mt-2",
      staticStyle: {
        "cursor": "default"
      },
      attrs: {
        "id": `edit-dictionary-attr-collapse-${index}`
      }
    }, [_c('b-card', {
      on: {
        "click": function ($event) {
          $event.stopPropagation();
        }
      }
    }, [_c('p', {
      staticStyle: {
        "white-space": "pre-line",
        "text-align": "left",
        "font-size": "13px",
        "font-weight": "bold"
      }
    }, [_vm._v(_vm._s(prop.propertyDefine))])])], 1)], 1) : _vm._e(), _vm.dictionaryAttribute.filter(function (item) {
      return item.active;
    }).length == 0 ? _c('div', [_vm._m(3, true)]) : _vm._e()]);
  })], 2)])]), _c('div', {
    staticClass: "popup_footer"
  }, [_c('a', {
    staticClass: "btn_type1",
    on: {
      "click": function ($event) {
        return _vm.saveProperty(false);
      }
    }
  }, [_vm._v("공정도속성 변경사항 저장")]), _c('a', {
    staticClass: "btn_type3",
    on: {
      "click": _vm.close
    }
  }, [_vm._v("닫기")])])]), _c('div', {
    staticClass: "mask_wrap",
    staticStyle: {
      "display": "block"
    }
  }), _c('Loading', {
    attrs: {
      "visible": _vm.loading,
      "type": "fixed"
    }
  })], 1);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "btn_close_box"
  }, [_c('span'), _c('span')]);

},function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('colgroup', [_c('col', {
    attrs: {
      "width": "30%"
    }
  }), _c('col', {
    attrs: {
      "width": "*"
    }
  })]);

},function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "nodata_txt"
  }, [_c('p', [_vm._v("적용된 공정도속성이 존재하지 않습니다.")])]);

},function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "nodata_txt"
  }, [_c('p', [_vm._v("속성POOL이 존재하지 않습니다."), _c('br'), _vm._v("우측 속성추가 버튼을 이용하여 추가해주세요")])]);

}]

export { render, staticRenderFns }